import React from "react"

export default function MenuCard(props) {
    const [popupState, changePopupState] = React.useState(false)
    const [cartState, changeCart] = React.useState(0)

    function changeCartStateUp() {
        changeCart(prevState => prevState + 1)
    }
    function changeCartStateDown() {
        if (cartState > 0) {
            changeCart(prevState => prevState - 1)
        }
    }

    function addToCart() {
        var array = [];
        array = JSON.parse(localStorage.getItem("cart")) || [];
        if (array.length) {
            let cartVerification = JSON.parse(localStorage.getItem("cart")).filter(data => data.header === props.header)

            if (cartVerification.length === 0 && cartState > 0) {
                array.push({
                    image: props.image,
                    header: props.header,
                    price: props.price,
                    description: props.description,
                    amount: cartState
                });
            }

        } else {
            if (cartState > 0) {
                array.push({
                    image: props.image,
                    header: props.header,
                    price: props.price,
                    description: props.description,
                    amount: cartState
                });
            }
        }
        
        localStorage.setItem("cart", JSON.stringify(array));
    }
    
    function addExtraToCart() {
        var array = [];
        array = JSON.parse(localStorage.getItem("cart")) || [];
        const index = array.findIndex(data => {
            return data.header == props.header
        })
        if (cartState) {
            array[index].amount = cartState;
        }
        localStorage.setItem("cart", JSON.stringify(array));
    }


    function cardPopup() {
        if (cartState > 0) {
            changePopupState(false)
            changePopupState(true)
            setTimeout(() => {
                changePopupState(false)
            }, 3000)
        }
        
    }

    function clickPopup() {
        changePopupState(false)
    }

    function addToCartFunctions() {
        addToCart()
        addExtraToCart()
        cardPopup()
        window.dispatchEvent(new Event("cart2"));
    }

    return (
        <>
            <div onClick={clickPopup} className={popupState ? "bestsellerPopup bestsellerPopupActivated" : "bestsellerPopup"}>
                <img src={props.image} className="bestsellerPopupImage" alt="sushi preview"/>
                <div className="popupInfo">
                    <p className="popupHeader">{props.header}</p>
                    <p className="popupPrice">{props.price}</p>
                    <p className="popupDescription">{props.description}</p>
                </div>
            </div>
            <div className="bestsellerCard" data-aos={props.animation} data-aos-once="true" data-aos-delay={props.delay} data-aos-duration={props.duration ? props.duration : 1000}>
                <div className="bestsellerCardImage">
                    <img src={props.image} alt="sushi"/>
                </div>
                <div className="bestsellerCardInfo1">
                    <p className="bestsellerCardHeader">{props.header}</p>
                    <p className="bestsellerCardPrice">{props.price}</p>
                </div>
                <p className="bestsellerCardDescription">{props.description}</p>
                <div className="betsellerCardButtons">
                    <div className="bestsellerCardAddToCart" onClick={addToCartFunctions}>Add to Cart</div>
                    <div className="bestsellerCardCartAmount">
                        <p onClick={changeCartStateUp}>+</p>
                        <p>{cartState}</p>
                        <p onClick={changeCartStateDown}>-</p>
                    </div>
                </div>
            </div>            
        </>
    )
}